var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 14,
    fill: "#DBD9D9"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Login screen",
    clipPath: "url(#clip0_3527_493)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    transform: "translate(-836 -661)",
    fill: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 3216"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 882",
    filter: "url(#filter0_d_3527_493)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -317,
    y: -198,
    width: 403,
    height: 310,
    rx: 8,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: -316.5,
    y: -197.5,
    width: 402,
    height: 309,
    rx: 7.5,
    stroke: "#236430",
    strokeOpacity: 0.1
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group 3215"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 3214"
  }, /*#__PURE__*/React.createElement("g", {
    id: "input"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 855",
    d: "M-255.563 -2.50558C-255.563 -4.19425 -254.194 -5.5632 -252.506 -5.5632H21.5056C23.1943 -5.5632 24.5632 -4.19426 24.5632 -2.50558V15.5056C24.5632 17.1943 23.1942 18.5632 21.5056 18.5632H-252.506C-254.194 18.5632 -255.563 17.1943 -255.563 15.5056V-2.50558Z",
    fill: "white",
    stroke: "#CED4DA",
    strokeWidth: 0.873606
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1083 13.0328L0.617584 0.0470184C0.573092 0.0114599 0.516301 -0.00497806 0.459694 0.00131721C0.403087 0.00761249 0.351295 0.0361259 0.315702 0.0805907L0.0471233 0.416583C0.0115346 0.461042 -0.00494831 0.517811 0.00129642 0.574416C0.00754115 0.631022 0.0360026 0.682833 0.0804271 0.718465L16.5712 13.7042C16.5932 13.7219 16.6185 13.735 16.6456 13.7429C16.6727 13.7507 16.7011 13.7532 16.7292 13.7501C16.7572 13.747 16.7844 13.7383 16.8091 13.7247C16.8339 13.7111 16.8557 13.6927 16.8733 13.6707L17.1419 13.3347C17.1774 13.2902 17.1939 13.2334 17.1876 13.1768C17.1813 13.1202 17.1528 13.0684 17.1083 13.0328ZM8.59437 2.57837C9.50583 2.57937 10.3797 2.94188 11.0242 3.58638C11.6687 4.23088 12.0312 5.10472 12.0322 6.01618C12.0322 6.59684 11.8737 7.13588 11.6186 7.6161L12.3021 8.15326C12.6674 7.52263 12.8916 6.79882 12.8916 6.01618C12.8916 5.027 12.5449 4.1278 11.9844 3.4021C13.4861 4.16023 14.7074 5.37684 15.4713 6.87563C15.0148 7.76192 14.3976 8.55569 13.6512 9.21656L14.3312 9.75211C15.0958 9.04628 15.7512 8.21422 16.2362 7.26749C16.2977 7.14595 16.3297 7.01168 16.3297 6.87549C16.3297 6.73931 16.2977 6.60504 16.2362 6.4835C14.7797 3.64167 11.8963 1.71892 8.59437 1.71892C7.388 1.71828 6.19579 1.97877 5.09962 2.48249L6.32891 3.44937C6.93563 2.91463 7.7231 2.57837 8.59437 2.57837ZM10.2289 6.52191C10.3131 6.26535 10.3348 5.99241 10.2922 5.72577C10.2497 5.45914 10.144 5.20652 9.98417 4.98893C9.82429 4.77134 9.61478 4.59506 9.37305 4.47476C9.13132 4.35446 8.86436 4.29361 8.59437 4.29727C8.56751 4.29727 8.54361 4.30372 8.51782 4.30506C8.62207 4.58423 8.61978 4.89203 8.51138 5.16962L10.2289 6.52191ZM4.38413 5.20158C4.32829 5.46957 4.29914 5.74244 4.29711 6.01618C4.29435 6.73616 4.47323 7.44521 4.8172 8.07772C5.16116 8.71023 5.6591 9.24577 6.26495 9.63479C6.87079 10.0238 7.56496 10.2537 8.28324 10.3033C9.00152 10.3529 9.7207 10.2205 10.3742 9.91836L9.57978 9.29284C9.26555 9.38764 8.93922 9.45398 8.59464 9.45398C7.68315 9.45299 6.80929 9.09048 6.16475 8.44599C5.5202 7.8015 5.15763 6.92766 5.15656 6.01618C5.15656 5.95064 5.17241 5.88941 5.1759 5.82495L4.38413 5.20158ZM8.59437 11.1729C5.71091 11.1729 3.07588 9.52623 1.71876 6.87563C2.18689 5.96246 2.82235 5.1911 3.55342 4.54652L2.85887 3.99942C2.09396 4.70525 1.4389 5.53703 0.953845 6.48377C0.892405 6.60531 0.860394 6.73958 0.860394 6.87576C0.860394 7.01194 0.892405 7.14622 0.953845 7.26775C2.40927 10.1096 5.29273 12.0323 8.59437 12.0323C9.80073 12.033 10.9929 11.7725 12.0891 11.2688L11.3035 10.651C10.4492 10.9806 9.53842 11.1729 8.59437 11.1729Z",
    fill: "#B6B7B8"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3527_493",
    x: -321,
    y: -198,
    width: 411,
    height: 318,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.454167 0 0 0 0 0.454167 0 0 0 0 0.454167 0 0 0 0.04 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3527_493"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3527_493",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3527_493"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1440,
    height: 1024,
    fill: "white",
    transform: "translate(-836 -661)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeCloseIcon);
export default __webpack_public_path__ + "static/media/eyeCloseIcon.af1f57d310decb21763144cb3a49591b.svg";
export { ForwardRef as ReactComponent };